export const loadingState = state => state.loadingState

export const goodsNavState = state => state.goodsNavState

export const orderType = state => state.orderType


// WEBPACK FOOTER //
// ./src/store/getters.js